import type { ISagaModule } from 'redux-dynamic-modules-saga'

import createNamedReducer from '../Audience/shared/AudienceInset/reducer'
import createNamedSagas from '../Audience/shared/AudienceInset/sagas'

import localSagas from './sagas'
import localReducer from './reducer'
import gearModeSagas from './sagas.gearmode'
import playbackReducer from './shared/reducer.playback'

const sagas = [
  ...localSagas,
  ...createNamedSagas('webinarAudience', '', { expireProfiles: true }),
  ...gearModeSagas,
]

const webinarModule: ISagaModule<unknown> = {
  id: 'webinar',
  reducerMap: {
    webinar: localReducer,
    webinarAudience: createNamedReducer('webinarAudience', {
      addNewRealtimeProfiles: true,
      expireProfiles: true,
    }),
    webinarPlayback: playbackReducer,
  },
  sagas,
}

export default webinarModule
